import AvailabilityManager from './AvailabilityManager.js';
import AvailabilityPresenter from './AvailabilityPresenter.js';
import ColumnCoverage from './ColumnCoverage.js';
import FeatureAvailability from './FeatureAvailability.js';
function configure({ domain, protocol }) {
    const prefix = `${protocol}://${domain}`;
    ColumnCoverage.$AR.url = `${prefix}/api/risym_data/v1/column-coverages`;
    FeatureAvailability.$AR.url = `${prefix}/api/geodata/risym-feature-availability-query`;
}
export { configure, AvailabilityManager, AvailabilityPresenter, ColumnCoverage, FeatureAvailability, };
export default {
    configure,
    AvailabilityManager,
    AvailabilityPresenter,
    ColumnCoverage,
    FeatureAvailability,
};
